









































import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import { Component } from "vue-property-decorator";
import { IState } from "@/store";
import { IBrand } from "@/models/brands";
@Component({
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  },
  computed: {
    ...mapGetters({
      brandId: "brand/id",
      brandName: "brand/name",
      hasMultipleBrands: "auth/admin/hasMultipleBrands"
    }),
    ...mapState({
      navIsCollapsed: (state: IState) => state.ui.nav.isCollapsed,
      navIsOpen: (state: IState) => state.ui.nav.isOpen
    })
  }
})
export default class AdminNavigationHeader extends Vue {
  public brandId!: IBrand["id"];
  public brandName!: IBrand["name"];
  public hasMultipleBrands!: boolean;
  public navIsCollapsed!: boolean;
  public navIsOpen!: boolean;
  public toggleMenu() {
    this.$store.commit("ui/collapseNav");
    this.$store.commit("ui/overlayNav", false);
    if (this.navIsCollapsed) {
      this.$bus.$emit("closeNavFooter");
    }
  }
}
